export const ACTIVE_BACKEND_ISSUES = Object.freeze(["iptal", "fatura", "iade", "hakem"]);

export const FLOW_VARIANTS = Object.freeze({
  CANCELLATION: "cancellation",
  INVOICE: "invoice",
  REFUND: "refund",
  PRODUCT_SERVICE: "product-service",
});

export const INVOICE_CATEGORIES = [
  { id: "telecom", label: "İnternet / telefon / TV", groups: ["telecom", "mobile"] },
  { id: "electricity", label: "Elektrik", names: ["Elektrik aboneliği"] },
  { id: "gas", label: "Doğalgaz", names: ["Doğalgaz aboneliği"] },
  { id: "water", label: "Su", names: ["Su aboneliği"] },
  { id: "bank", label: "Banka veya kredi kartı", names: ["Diğer"] },
  { id: "digital", label: "Dijital üyelik", groups: ["digital"] },
  { id: "dues", label: "Site / aidat / ortak gider", names: ["Diğer"] },
  { id: "other", label: "Başka bir fatura", names: ["Diğer"] },
];

export const REFUND_CATEGORIES = [
  { id: "online-product", label: "İnternetten aldığım ürün", groups: ["ecommerce"] },
  { id: "not-delivered", label: "Teslim edilmeyen sipariş", groups: ["ecommerce"] },
  { id: "cancelled-service", label: "İptal edilen hizmet", groups: ["digital"] },
  { id: "ticket", label: "Bilet / rezervasyon", names: ["Diğer"] },
  { id: "education", label: "Kurs / eğitim", names: ["Online eğitim / kurs"] },
  { id: "digital", label: "Dijital üyelik", groups: ["digital"] },
  { id: "deposit", label: "Depozito / kapora", names: ["Diğer"] },
  { id: "duplicate", label: "Hatalı veya çift ödeme", names: ["Diğer"] },
  { id: "defective", label: "Ayıplı ürün", groups: ["ecommerce"] },
  { id: "other", label: "Başka bir ödeme", names: ["Diğer"] },
];

export const PRODUCT_PROBLEMS = [
  { id: "defective", label: "Ürün bozuk veya ayıplı", value: "Ürün ayıplı çıktı" },
  { id: "wrong-product", label: "Eksik / yanlış ürün", value: "Yanlış / eksik ürün geldi" },
  { id: "service", label: "Servis sorunu", value: "Satıcı cevap vermiyor" },
  { id: "warranty", label: "Garanti sorunu", value: "Ürün ayıplı çıktı" },
  { id: "replacement", label: "Değişim talebi", value: "Ürünü iade etmek istiyorum" },
  { id: "repair-delay", label: "Tamir süresi uzadı", value: "Satıcı cevap vermiyor" },
  { id: "poor-service", label: "Hizmet eksik veya kötü verildi", value: "Satıcı cevap vermiyor" },
  { id: "installation", label: "Montaj / kurulum sorunu", value: "Ürün ayıplı çıktı" },
  { id: "repeated-fault", label: "Tekrarlayan arıza", value: "Ürün ayıplı çıktı" },
  { id: "other", label: "Başka bir ürün veya hizmet sorunu", value: "Satıcı cevap vermiyor" },
];

export const PRODUCT_OUTCOMES = [
  { id: "repair", label: "Ücretsiz onarım", sentence: "Ürünün ücretsiz onarılmasını istiyorum." },
  { id: "replacement", label: "Ürün değişimi", sentence: "Ürünün ayıpsız bir ürünle değiştirilmesini istiyorum." },
  { id: "completion", label: "Eksik parçanın tamamlanması", sentence: "Eksik parçanın tamamlanmasını istiyorum." },
  { id: "service-again", label: "Hizmetin yeniden verilmesi", sentence: "Hizmetin eksiksiz biçimde yeniden verilmesini istiyorum." },
  { id: "discount", label: "Ücret indirimi", sentence: "Sorunla orantılı ücret indirimi yapılmasını istiyorum." },
  { id: "refund", label: "Para iadesi", sentence: "Ödediğim bedelin iade edilmesini istiyorum." },
  { id: "assessment", label: "Önce durumumu değerlendirin", sentence: "Durumumun incelenerek uygun çözümün yazılı olarak bildirilmesini istiyorum." },
  { id: "other", label: "Başka bir çözüm", sentence: "Aşağıda belirttiğim çözüm talebimin değerlendirilmesini istiyorum." },
];

const invoiceOptions = [
  ["high", "Fatura beklediğimden çok yüksek", "Haksız fatura kesildi"],
  ["unused", "Kullanmadığım hizmet için ücret alındı", "Kullanmadığım hizmet için ücret kesildi"],
  ["after-cancel", "İptal etmeme rağmen fatura geldi", "İptal sonrası fatura devam ediyor"],
  ["extra", "Taahhüt dışında ek ücret çıktı", "Taahhüt sonrası ekstra ücret geldi"],
  ["duplicate", "Aynı ücret iki kez alındı", "Haksız fatura kesildi"],
  ["termination", "Cayma bedeli yansıtıldı", "Cayma bedeli çıkardılar"],
  ["device", "Kurulum / cihaz / modem ücreti çıkarıldı", "Haksız fatura kesildi"],
  ["meter", "Sayaç veya tüketim hatası olduğunu düşünüyorum", "Haksız fatura kesildi"],
  ["discount", "İndirim uygulanmadı", "Haksız fatura kesildi"],
  ["unclear", "Faturanın nasıl hesaplandığını anlayamıyorum", "Haksız fatura kesildi"],
  ["previous", "Daha önce itiraz ettim ama sonuç alamadım", "Haksız fatura kesildi"],
  ["other", "Başka bir fatura sorunu", "Haksız fatura kesildi"],
];

const refundOptions = [
  ["rejected", "İade talebim reddedildi", "İadem reddedildi"],
  ["returned-no-money", "Ürünü gönderdim ama param gelmedi", "Para iadem yatmadı"],
  ["not-delivered", "Sipariş hiç teslim edilmedi", "Siparişimi iptal edemiyorum"],
  ["not-provided", "Hizmet verilmedi", "Siparişimi iptal edemiyorum"],
  ["cancelled-no-refund", "İptal edildi ama ücret geri yatmadı", "Para iadem yatmadı"],
  ["partial", "Eksik tutar iade edildi", "Para iadem yatmadı"],
  ["delayed", "İade süresi çok uzadı", "Para iadem yatmadı"],
  ["unreachable", "Satıcıya ulaşamıyorum", "Satıcı cevap vermiyor"],
  ["bank-missing", "İade edildi deniliyor ama hesabımda görünmüyor", "Para iadem yatmadı"],
  ["deposit", "Kapora veya depozito geri verilmiyor", "İadem reddedildi"],
  ["duplicate", "Aynı ödeme iki kez alındı", "Para iadem yatmadı"],
  ["other", "Başka bir iade sorunu", "İadem reddedildi"],
];

const toOptions = (items) => items.map(([id, label, value]) => ({ id, label, value }));

export const FLOW_CONFIG = {
  invoice: {
    issue: "fatura",
    resultSubtitle: "Fatura itirazınızı uygun kanaldan göndererek işlemi tamamlayın.",
    problemTitle: "Faturanızda ne sorun var?",
    problemOptions: toOptions(invoiceOptions),
    agentNote: "Fatura itirazınız için gerekli işlem ve hesap bilgilerini belirledim. Kurumun uygun başvuru kanalını kontrol edeceğim.",
    infoFields: [
      ["billingPeriod", "Fatura dönemi", "Örn. Haziran 2026"],
      ["invoiceAmount", "Fatura tutarı", "Örn. 1.250 TL"],
      ["disputedAmount", "İtiraz edilen tutar (biliniyorsa)", "Örn. 450 TL"],
      ["invoiceNumber", "Fatura veya hesap numarası", ""],
      ["previousApplication", "Önceki başvuru tarihi ve numarası (varsa)", ""],
    ],
    documents: ["Fatura", "Ödeme dekontu", "Sözleşme / tarife bilgisi", "Önceki başvuru", "Kurum cevabı", "Ekran görüntüsü"],
  },
  refund: {
    issue: "iade",
    resultSubtitle: "Para iadesi talebinizi uygun kanaldan göndererek işlemi tamamlayın.",
    problemTitle: "İade sürecinde ne yaşıyorsunuz?",
    problemOptions: toOptions(refundOptions),
    agentNote: "İade talebinizi destekleyecek işlem bilgilerini ve belgeleri belirledim.",
    infoFields: [
      ["transactionNumber", "Sipariş / rezervasyon / işlem numarası", ""],
      ["paymentDate", "Ödeme tarihi", ""],
      ["paidAmount", "Ödenen tutar", "Örn. 1.250 TL"],
      ["refundAmount", "Talep edilen iade tutarı", ""],
      ["refundRequestDate", "İade talep tarihi", ""],
      ["paymentMethod", "Ödeme yöntemi", ""],
      ["previousApplication", "Daha önce yapılan başvuru (varsa)", ""],
    ],
    documents: ["Fatura / fiş", "Ödeme dekontu", "Sipariş ekranı", "İade kargo belgesi", "İptal onayı", "Kurum veya satıcı cevabı", "Ekran görüntüsü"],
  },
  "product-service": {
    issue: "iade",
    resultSubtitle: "Ürün veya hizmet sorununuz için hazırlanan talebi uygun kanaldan göndererek işlemi tamamlayın.",
    problemTitle: "Sorununuzu en iyi hangisi anlatıyor?",
    problemOptions: PRODUCT_PROBLEMS,
    agentNote: "Talep ettiğiniz çözümü başvuru metnine ekledim. Şimdi kurumun uygun başvuru kanalını kontrol ediyorum.",
    infoFields: [
      ["productName", "Ürün veya hizmet adı", ""],
      ["purchaseDate", "Satın alma tarihi", ""],
      ["transactionNumber", "Sipariş / fatura numarası", ""],
      ["paidAmount", "Ödenen tutar", ""],
      ["faultDescription", "Arızanın veya eksikliğin kısa açıklaması", ""],
      ["serviceDate", "Servise teslim tarihi (varsa)", ""],
      ["serviceNumber", "Servis kayıt numarası (varsa)", ""],
      ["warrantyStatus", "Garanti durumu", ""],
    ],
    documents: ["Fatura", "Garanti belgesi", "Servis fişi", "Ürün fotoğrafı", "Video", "Yazışmalar", "Ekran görüntüsü"],
  },
};

export const TELECOM_GATE_OPTIONS = [
  ["cancel", "Aboneliğimi iptal etmek istiyorum"],
  ["invoice", "Faturama itiraz etmek istiyorum"],
  ["service", "Hizmet alamıyorum / kesinti yaşıyorum"],
  ["termination", "Cayma bedeli sorunum var"],
  ["device", "Modem / cihaz sorunum var"],
  ["unreachable", "Kuruma ulaşamıyorum"],
  ["other", "Başka bir sorun"],
].map(([id, label]) => ({ id, label }));

export function filterGroupsForFlow(groups, flow, categoryId) {
  const source = flow === FLOW_VARIANTS.INVOICE ? INVOICE_CATEGORIES : REFUND_CATEGORIES;
  const category = source.find((item) => item.id === categoryId);
  if (!category) return groups;
  return groups.map((group) => ({
    ...group,
    items: group.items.filter((name) => category.groups?.includes(group.id) || category.names?.includes(name)),
  })).filter((group) => group.items.length);
}

export function buildFlowDescription({ flow, problemLabel, desiredOutcome, info = {}, selectedLabels = [], freeText = "" }) {
  const parts = [];
  if (problemLabel) parts.push(`Seçilen durum: ${problemLabel}.`);
  if (desiredOutcome) parts.push(desiredOutcome);
  Object.entries(info).forEach(([key, value]) => {
    const label = FLOW_CONFIG[flow]?.infoFields.find(([field]) => field === key)?.[1];
    if (label && String(value || "").trim()) parts.push(`${label}: ${String(value).trim()}.`);
  });
  selectedLabels.forEach((label) => parts.push(`Ek durum: ${label}.`));
  if (String(freeText).trim()) parts.push(/[.!?]$/.test(freeText.trim()) ? freeText.trim() : `${freeText.trim()}.`);
  return parts.join(" ");
}
